import { useEffect, useState } from 'react'
import { Select, Switch } from 'antd'
import { useCreateMacroData } from '../CreateMacroDataProvider'
import { setFieldData } from '../CreateMacroDataProvider/actions'
import { orientation } from '../constants'
import { getRelKeyBindings } from 'Services/WeaverUtils'
import FormLikeField from './FormLikeField'
import './RelationConfig.scss'

RelationConfig = ({ fieldKey }) ->

  [{ fieldData }, dispatch] = useCreateMacroData()
  [options, setOptions] = useState([])
  [search, setSearch] = useState(undefined)
  [direction, setDirection] = useState(orientation.IN)
  [isMultiple, setIsMultiple] = useState(false)

  useEffect( ->
    ( ->
      relKeyBindings = await getRelKeyBindings()
      setOptions(relKeyBindings.key.map(({ nodeId }) ->
        { label: nodeId, value: nodeId } )
      )
    )()
    undefined
  , [])

  useEffect( ->
    ( ->
      return unless direction? and isMultiple?
      relKeyBindings = await getRelKeyBindings()
      saveConfig = {
        type: 'relation'
        orientation: fieldData[fieldKey]?.save?.orientation or direction,
        relationName: fieldData[fieldKey]?.save?.relationName or relKeyBindings.key.map((node) -> node.id())[0]
      }
      setRelationConfig('save')(saveConfig)
    )()
    undefined
  , [direction, isMultiple])

  setRelationConfig = (keys...) -> (value) ->
    dispatch(
      setFieldData(
        _.set(fieldData, [fieldKey, keys...], value)
      )
    )

  <div className="relation-rules">
    <FormLikeField label="Relation name to use" key="#{fieldKey}-relationName-config">
      <Select
        onSearch={(val) -> setSearch(val) if val isnt ''}
        showSearch
        style={{ width: '100%' }}
        options={_.uniqBy(options.concat([{ value: search, label: search }]), 'value')}
        value={fieldData[fieldKey]?.save?.relationName}
        onChange={setRelationConfig('save', 'relationName')}
      />
    </FormLikeField>
    <FormLikeField label="Orientation" key="#{fieldKey}-orientation-config">
      <Switch
        checked={fieldData[fieldKey]?.save?.orientation is orientation.OUT}
        onChange={(checked) ->
          val = checked && orientation.OUT || orientation.IN
          setRelationConfig('save', 'orientation')(val)
        }
        checkedChildren="Outgoing relation"
        unCheckedChildren="Incoming relation"
      />
    </FormLikeField>
    <FormLikeField label="Multiple?" key="#{fieldKey}-is-multiple-config">
      <Switch
        checked={
          if fieldData[fieldKey]?.save?.orientation is orientation.IN
            false
          else
            fieldData[fieldKey]?.config?.mode is 'multiple'
        }
        onChange={(checked) ->
          val = checked && 'multiple'
          setRelationConfig('config', 'mode')(val)
        }
        disabled={fieldData[fieldKey]?.save?.orientation is orientation.IN}
        checkedChildren="Multiple targets permitted"
        unCheckedChildren="Single target permitted"
      />
    </FormLikeField>
  </div>
export default RelationConfig
